import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-fixed border divide-ternary text-center align-middle w-full text-brown" }
const _hoisted_2 = { class: "border divide-ternary" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "max-w-96 text-left" }
const _hoisted_6 = { class: "border divide-ternary" }
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = { class: "max-w-96 text-left" }
const _hoisted_10 = { class: "border divide-ternary" }
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "mb-0" }
const _hoisted_13 = { class: "max-w-96 text-left" }
const _hoisted_14 = { class: "border divide-ternary" }
const _hoisted_15 = { class: "mb-0" }
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = { class: "max-w-96 text-left" }
const _hoisted_18 = {
  colspan: "3",
  rowspan: "3",
  class: "p-0 align-middle"
}
const _hoisted_19 = { class: "flex justify-center items-center h-full" }
const _hoisted_20 = { class: "border divide-ternary" }
const _hoisted_21 = { class: "mb-0" }
const _hoisted_22 = { class: "mb-0" }
const _hoisted_23 = { class: "max-w-96 text-left" }
const _hoisted_24 = { class: "border divide-ternary" }
const _hoisted_25 = { class: "mb-0" }
const _hoisted_26 = { class: "mb-0" }
const _hoisted_27 = { class: "max-w-96 text-left" }
const _hoisted_28 = { class: "border divide-ternary" }
const _hoisted_29 = { class: "mb-0" }
const _hoisted_30 = { class: "mb-0" }
const _hoisted_31 = { class: "max-w-96 text-left" }
const _hoisted_32 = { class: "border divide-ternary" }
const _hoisted_33 = { class: "mb-0" }
const _hoisted_34 = { class: "mb-0" }
const _hoisted_35 = { class: "max-w-96 text-left" }
const _hoisted_36 = { class: "border divide-ternary" }
const _hoisted_37 = { class: "mb-0" }
const _hoisted_38 = { class: "mb-0" }
const _hoisted_39 = { class: "max-w-96 text-left" }
const _hoisted_40 = { class: "border divide-ternary" }
const _hoisted_41 = { class: "mb-0" }
const _hoisted_42 = { class: "mb-0" }
const _hoisted_43 = { class: "max-w-96 text-left" }
const _hoisted_44 = { class: "border divide-ternary" }
const _hoisted_45 = { class: "mb-0" }
const _hoisted_46 = { class: "mb-0" }
const _hoisted_47 = { class: "max-w-96 text-left" }
const _hoisted_48 = { class: "border divide-ternary" }
const _hoisted_49 = { class: "mb-0" }
const _hoisted_50 = { class: "mb-0" }
const _hoisted_51 = { class: "max-w-96 text-left" }


import AppTooltip from "@/components/AppTooltip.vue";
import { Pillar, TwelvePalace } from "@/types/calculators";
import NatalPalacesPillarTable from "@/views/Calculators/BaZiPrediction/components/NatalPalacesPillarTable.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NatalPalaces',
  props: {
    pillars: {},
    palaces: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tbody", null, [
      _createElementVNode("tr", null, [
        _cache[0] || (_cache[0] = _createElementVNode("td", { class: "border divide-ternary" }, null, -1)),
        _createElementVNode("td", _hoisted_2, [
          _createVNode(AppTooltip, null, {
            trigger: _withCtx(() => [
              _createElementVNode("h5", _hoisted_3, _toDisplayString(__props.palaces.wealth.label), 1),
              _createElementVNode("h5", _hoisted_4, _toDisplayString(__props.palaces.wealth.hieroglyph), 1)
            ]),
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, _toDisplayString(__props.palaces.wealth.description), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("td", _hoisted_6, [
          _createVNode(AppTooltip, null, {
            trigger: _withCtx(() => [
              _createElementVNode("h5", _hoisted_7, _toDisplayString(__props.palaces.health.label), 1),
              _createElementVNode("h5", _hoisted_8, _toDisplayString(__props.palaces.health.hieroglyph), 1)
            ]),
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, _toDisplayString(__props.palaces.health.description), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("td", _hoisted_10, [
          _createVNode(AppTooltip, null, {
            trigger: _withCtx(() => [
              _createElementVNode("h5", _hoisted_11, _toDisplayString(__props.palaces.travel.label), 1),
              _createElementVNode("h5", _hoisted_12, _toDisplayString(__props.palaces.travel.hieroglyph), 1)
            ]),
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, _toDisplayString(__props.palaces.travel.description), 1)
            ]),
            _: 1
          })
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("td", { class: "border divide-ternary" }, null, -1))
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_14, [
          _createVNode(AppTooltip, null, {
            trigger: _withCtx(() => [
              _createElementVNode("h5", _hoisted_15, _toDisplayString(__props.palaces.friends.label), 1),
              _createElementVNode("h5", _hoisted_16, _toDisplayString(__props.palaces.friends.hieroglyph), 1)
            ]),
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, _toDisplayString(__props.palaces.friends.description), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("td", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(NatalPalacesPillarTable, { pillars: __props.pillars }, null, 8, ["pillars"])
          ])
        ]),
        _createElementVNode("td", _hoisted_20, [
          _createVNode(AppTooltip, null, {
            trigger: _withCtx(() => [
              _createElementVNode("h5", _hoisted_21, _toDisplayString(__props.palaces.career.label), 1),
              _createElementVNode("h5", _hoisted_22, _toDisplayString(__props.palaces.career.hieroglyph), 1)
            ]),
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_23, _toDisplayString(__props.palaces.career.description), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_24, [
          _createVNode(AppTooltip, null, {
            trigger: _withCtx(() => [
              _createElementVNode("h5", _hoisted_25, _toDisplayString(__props.palaces.property.label), 1),
              _createElementVNode("h5", _hoisted_26, _toDisplayString(__props.palaces.property.hieroglyph), 1)
            ]),
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_27, _toDisplayString(__props.palaces.property.description), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("td", _hoisted_28, [
          _createVNode(AppTooltip, null, {
            trigger: _withCtx(() => [
              _createElementVNode("h5", _hoisted_29, _toDisplayString(__props.palaces.fortune.label), 1),
              _createElementVNode("h5", _hoisted_30, _toDisplayString(__props.palaces.fortune.hieroglyph), 1)
            ]),
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_31, _toDisplayString(__props.palaces.fortune.description), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_32, [
          _createVNode(AppTooltip, null, {
            trigger: _withCtx(() => [
              _createElementVNode("h5", _hoisted_33, _toDisplayString(__props.palaces.parents.label), 1),
              _createElementVNode("h5", _hoisted_34, _toDisplayString(__props.palaces.parents.hieroglyph), 1)
            ]),
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_35, _toDisplayString(__props.palaces.parents.description), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("td", _hoisted_36, [
          _createVNode(AppTooltip, null, {
            trigger: _withCtx(() => [
              _createElementVNode("h5", _hoisted_37, _toDisplayString(__props.palaces.life.label), 1),
              _createElementVNode("h5", _hoisted_38, _toDisplayString(__props.palaces.life.hieroglyph), 1)
            ]),
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_39, _toDisplayString(__props.palaces.life.description), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[2] || (_cache[2] = _createElementVNode("td", { class: "border divide-ternary" }, null, -1)),
        _createElementVNode("td", _hoisted_40, [
          _createVNode(AppTooltip, null, {
            trigger: _withCtx(() => [
              _createElementVNode("h5", _hoisted_41, _toDisplayString(__props.palaces.appearance.label), 1),
              _createElementVNode("h5", _hoisted_42, _toDisplayString(__props.palaces.appearance.hieroglyph), 1)
            ]),
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_43, _toDisplayString(__props.palaces.appearance.description), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("td", _hoisted_44, [
          _createVNode(AppTooltip, null, {
            trigger: _withCtx(() => [
              _createElementVNode("h5", _hoisted_45, _toDisplayString(__props.palaces.marriage.label), 1),
              _createElementVNode("h5", _hoisted_46, _toDisplayString(__props.palaces.marriage.hieroglyph), 1)
            ]),
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_47, _toDisplayString(__props.palaces.marriage.description), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("td", _hoisted_48, [
          _createVNode(AppTooltip, null, {
            trigger: _withCtx(() => [
              _createElementVNode("h5", _hoisted_49, _toDisplayString(__props.palaces.children.label), 1),
              _createElementVNode("h5", _hoisted_50, _toDisplayString(__props.palaces.children.hieroglyph), 1)
            ]),
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_51, _toDisplayString(__props.palaces.children.description), 1)
            ]),
            _: 1
          })
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("td", { class: "border divide-ternary" }, null, -1))
      ])
    ])
  ]))
}
}

})